export default __webpack_public_path__ + "static/media/ser5.dc1b1781.svg";